export enum BillFormView {
  create = 'bill_create_view',
  edit = 'bill_edit_view',
}
